export function initMobileMenu(): void {
  const menuIcon = document.getElementById('open-menu-icon')
  const overlay = document.getElementById('mobile-menu-overlay')

  if (!menuIcon || !overlay) return

  const closeIcon = overlay.querySelector('.close-mobile-menu')

  closeIcon?.addEventListener('click', () => {
    overlay.classList.add('hidden')
  })

  menuIcon.addEventListener('click', () => {
    overlay.classList.remove('hidden')
  })
}

export function initStickyHeader(): void {
  const header = document.querySelector('header.main-header')
  if (!(header instanceof HTMLElement)) return

  window.addEventListener('scroll', () => {
    if (header.offsetTop >= 80) {
      header.classList.add('sticky')
    } else {
      header.classList.remove('sticky')
    }
  })
}
